const { BigNumber } = require('ethers')

exports.BIG_NUMBER_ZERO = BigNumber.from(0)
exports.BIG_NUMBER_ONE = BigNumber.from(1)
exports.BIG_NUMBER_TWO = BigNumber.from(2)
exports.BIG_NUMBER_TEN = BigNumber.from(10)
